import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Typography } from '@material-ui/core';
import { assegneeSuggestionsContext } from '../AssegneeSuggestionsContext';
import { DeleteIconButton } from 'components';
import { applicationContext } from 'helpers/services';


let Results = () => {
    let { assignableUsers, ticketTypes } = useContext(applicationContext);
    let service = useContext(assegneeSuggestionsContext);

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Typology</TableCell>
                    <TableCell>Assegnee</TableCell>
                    <TableCell>Product</TableCell>
                    <TableCell>Product condition</TableCell>
                    <TableCell />
                </TableRow>
            </TableHead>
            <TableBody>
                {service.suggestions.map((suggestion, index) =>
                    <TableRow hover key={index}>
                        <TableCell>{ticketTypes.find(x => x.id === suggestion.ticketTypeId)?.name}</TableCell>
                        <TableCell>{assignableUsers.find(x => x.email === suggestion.assignee)?.name}</TableCell>
                        <TableCell>
                            {suggestion.product}
                        </TableCell>
                        <TableCell>
                            {suggestion.productStatus}
                        </TableCell>
                        <TableCell align="right">
                            <DeleteIconButton onClick={() => service.deleteAssegneeSuggestion(suggestion.id)} stopPropagation />
                        </TableCell>
                    </TableRow>
                )}
            </TableBody>
            {service.suggestions.length === 0 &&
                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={5}>
                            <Typography variant="subtitle2">No ticket suggestions found</Typography>
                        </TableCell>
                    </TableRow>
                </TableFooter>
            }
        </Table>
    );
}

export default Results;